/**
 * tRPC 컨텍스트 계약.
 *
 * 이 패키지는 api ↔ web/admin 사이의 "전송 계약"만 정의한다.
 * DB 스키마(@repo/database)에 의존하지 않아야 프론트엔드 번들이 서버 코드를 끌어오지 않는다.
 */

export const USER_ROLES = ['USER', 'ADMIN'] as const;
export type UserRole = (typeof USER_ROLES)[number];

/**
 * 계정 상태 5종의 나열 — 순서에 의미를 두지 않는다.
 *
 * 우선순위(DELETED > BLOCKED > PENDING_EMAIL > PENDING_IDENTITY > ACTIVE)는
 * 이 배열이 아니라 account-status.ts 의 deriveAccountStatus 가 결정한다 —
 * 배열 순서를 바꿔도 판정은 변하지 않는다.
 */
export const ACCOUNT_STATUSES = [
  'DELETED',
  'BLOCKED',
  'PENDING_EMAIL',
  'PENDING_IDENTITY',
  'ACTIVE',
] as const;
export type AccountStatus = (typeof ACCOUNT_STATUSES)[number];

export interface AuthenticatedUser {
  readonly id: string;
  readonly email: string;
  readonly role: UserRole;
  /**
   * 액세스 토큰 페이로드에 실린 계정 상태. 요청마다 DB 를 조회하지 않기 위함이다.
   * 차단(강등)은 토큰 만료를 기다릴 수 없으므로 Redis Pub/Sub 로 별도 전파한다.
   */
  readonly status: AccountStatus;
}

export interface TrpcContext {
  /** 인증되지 않은 요청이면 null. */
  readonly user: AuthenticatedUser | null;
  /** 요청 추적용 상관관계 ID. 로그와 에러 응답에 함께 남긴다. */
  readonly requestId: string;
  /** 감사 로그용 접속 정보. 프록시 뒤에서는 신뢰 설정에 따라 달라질 수 있다. */
  readonly ipAddress: string | null;
  readonly userAgent: string | null;
}
